import HBIcon from "@/components/HBIcon";
import HBInput from "@/components/HBInput";
import { useState } from "react";
import styles from "../index.module.less";

export default function Password(props) {
  const [hidePwd, setHidePwd] = useState(true);
  return (
    <HBInput
      {...props}
      className={styles.password}
      type={hidePwd ? "password" : "text"}
      addonAfter={
        <HBIcon
          className={styles.visibilityIcon}
          onClick={() => {
            setHidePwd(!hidePwd);
          }}
          type={hidePwd ? "visibility" : "visibility_off"}
        />
      }
    />
  );
}
